// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"shared_bodyText__1HT8o","alertModalButtons":"shared_alertModalButtons__3ANEH","alertModalWrapper":"shared_alertModalWrapper__uPXuM"};